<template>

    <div>

        <widget_panel_component :widgets="widgets"></widget_panel_component>

    </div>

</template>

<script>


    import Vue from 'vue'
    import upperFirst from 'lodash/upperFirst'
    import camelCase from 'lodash/camelCase'
    import widget_panel_component from "../_app/_widget-panel/widget_panel_component";

    const requireComponent = require.context('./widgets', true, /[A-Z]\w+\.(vue|js)$/)

    const widgets = [];

    requireComponent.keys().forEach(fileName => {

        const componentConfig = requireComponent(fileName)
        const componentName = upperFirst(camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1')))

        let conf = componentConfig.default.wconf;

        conf.component = componentName;

        widgets.push(conf);


        // Register component globally
        Vue.component(componentName, componentConfig.default || componentConfig)
    })


    export default {

        name: 'dashboard_component.vue',
        components: {


            widget_panel_component

        },
        mixins: [],

        data() {
            return {
                widgets: widgets
            }
        }




    }

</script>